export const formatPrice = (number) => {
  if (isNaN(number)) return ''
  const fixedNumber = Number(number).toFixed(2)
  return fixedNumber.replace('.', ',')
}
